<template>
    <text-input
      :label="label"
      :prop="prop"
      :required="required"
      type="number"
      v-model="form"
      :step="step"
      :decimals="0"
      :size="size"
      align-input="right"
      :min="min"
      :max="max"
      :prefix="prefix"
      :suffix="suffix"
      :is-prefix-icon="isPrefixIcon"
      :is-suffix-icon="isSuffixIcon"
      @input="v = parseFloat($event)"
     :disabled="disabled"
     :no-form="noForm"
     :placeholder="placeholder"
     @change="updated">
   </text-input>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'integer-input',

  mixins: [NumberMixins],

  props: {
    label: {
      type: String,
      default: null
    },
    value: {
//      type: Number,
      required: true
    },
    prop: {
      type: String,
      default: null
    },
    decimals: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },

    size: {
      type: String,
      default: 'default'
    },

    prefix: {
      type: String,
      default: null
    },

    suffix: {
      type: String,
      default: null
    },

    isPrefixIcon: {
      type: Boolean,
      default: false
    },

    isSuffixIcon: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.form = Math.round(value, 0)
      this.$emit('input', Math.round(value, 0))
      this.$emit('change', Math.round(value, 0))
    }
  },

  watch: {
    value: function (val) {
      this.form = val
    }
  },


  data () {
    return {
      form: this.value
    }
  }
}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// IntegerInput.vue?950f2bd6